export const TextEffectsStickerViewerType = 'wixui.TextEffectsSticker' as const;
export const TestIds = {
  viewer: {
    container: 'TextEffectsSticker-container',
    text: 'TextEffectsSticker-text',
  },
} as const;
